import { render, staticRenderFns } from "./Histories.vue?vue&type=template&id=b9a540a2&scoped=true"
import script from "./Histories.vue?vue&type=script&lang=ts"
export * from "./Histories.vue?vue&type=script&lang=ts"
import style0 from "./Histories.vue?vue&type=style&index=0&id=b9a540a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a540a2",
  null
  
)

export default component.exports